/** 与后端 app.deps 中 get_effective_role / perm_keys 口径一致（登录、/auth/me 已返回 effective role）。 */

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
}

export function getEffectiveRole(user) {
  const role = Number(user?.role);
  if (!Number.isFinite(role) || role < 1) return 1;
  return Math.min(3, Math.max(1, role));
}

export function isSuperAdmin(user) {
  return getEffectiveRole(user) >= 3;
}

export function isRegionManager(user) {
  return getEffectiveRole(user) === 2;
}

export function getPermKeys(user) {
  return Array.isArray(user?.perm_keys) ? user.perm_keys : [];
}

export function hasPerm(user, permKey) {
  return getPermKeys(user).includes(permKey);
}

export function canApproveAny(user) {
  return hasPerm(user, 'approve_borrow')
    || hasPerm(user, 'approve_change')
    || hasPerm(user, 'approve_scrap');
}

export const ROLE_LABELS = {
  1: '普通用户',
  2: '区域管理员',
  3: '超级管理员',
};

export function getRoleLabel(user) {
  return ROLE_LABELS[getEffectiveRole(user)] || '普通用户';
}
